export const normalizePhone = (value) => {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  if (onlyNums.length <= 3) return onlyNums;
  if (onlyNums.length <= 7)
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 7)}`;
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`;
};

export function isValidEmail(value) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
}

export function isValidPhoneNumber(phoneNumber) {
  const regex = /^(1\s?)?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/;
  return regex.test(phoneNumber);
}

export function formatDob(value) {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  console.log("DOB length", onlyNums.length);
  if (onlyNums.length <= 2) return onlyNums;
  if (onlyNums.length <= 4)
    return `${onlyNums.slice(0, 2)} / ${onlyNums.slice(2, 4)}`;

  return `${onlyNums.slice(0, 2)} / ${onlyNums.slice(2, 4)} / ${onlyNums.slice(
    4,
    8
  )}`;
}

export function formatZip(value) {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  return `${onlyNums.slice(0, 5)}`;
}
